<template>
    <v-overlay :value="overlay">
        <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-overlay>
</template>

<script>
export default {
    props: {
        overlay: Boolean,
    }
}
</script>

<style scoped>
    .loading-overlay {
        z-index: 10;
        top: 0;
        left: 0;
        right: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(135, 226, 209, 0.3);
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>


